// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"1e48ff88","82":"dc74eb36","99":"0b3a22f5","136":"a16dd1a0","253":"0efbec24","759":"f3c762da"}[chunkId] + ".chunk.css";
};